module.exports = __webpack_public_path__ + "img/61.4.NH3-N.6868da45.png";